/**
 * PATH: packages/pricelist/src/pricelistMobileMenus.ts
 * FILE_ID: PKG-PRICELIST-MOBILE-MENUS-001
 * PURPOSE: Pure builders for pricelist mobile bottom-sheet action items.
 * WHY: Phone long-press / ⋯ must mirror RowContextMenu actions without
 *      duplicating labels in the host; desktop right-click stays floating.
 */
import { ArrowDown, ArrowUp, Copy, EyeOff, SlidersHorizontal, Trash2 } from 'lucide-react'
import type { MobileActionSheetItem } from '@quotech/ui/mobile'

export interface RowSheetActions {
  onInsertAbove: () => void
  onInsertBelow: () => void
  onDuplicate: () => void
  onDelete: () => void
}

export function buildRowActionSheetItems(actions: RowSheetActions): MobileActionSheetItem[] {
  return [
    {
      id: 'above',
      label: 'Insert row above',
      icon: ArrowUp,
      onSelect: actions.onInsertAbove,
    },
    {
      id: 'below',
      label: 'Insert row below',
      icon: ArrowDown,
      onSelect: actions.onInsertBelow,
    },
    {
      id: 'dup',
      label: 'Duplicate row',
      icon: Copy,
      onSelect: actions.onDuplicate,
    },
    {
      id: 'del',
      label: 'Delete row',
      icon: Trash2,
      destructive: true,
      onSelect: actions.onDelete,
    },
  ]
}

export interface HeaderSheetActions {
  onHide: () => void
  onManage: () => void
  hiding?: boolean
}

export function buildHeaderActionSheetItems(
  actions: HeaderSheetActions,
): MobileActionSheetItem[] {
  return [
    {
      id: 'hide',
      label: actions.hiding ? 'Hiding…' : 'Hide column (all sections)',
      icon: EyeOff,
      disabled: Boolean(actions.hiding),
      onSelect: actions.onHide,
    },
    {
      id: 'manage',
      label: 'Manage columns…',
      icon: SlidersHorizontal,
      onSelect: actions.onManage,
    },
  ]
}
